import { useTranslation } from "react-i18next";
import { Button } from "@chakra-ui/react";

import { useOktaOidcLogin } from "modules/authentication/hooks/useOktaOidcLogin";
import { OktaOidcCredentialsFormSchema } from "modules/authentication/schemas/oktaOidcCredentialsFormSchema";

import { SSOAuthenticationBox } from "modules/authentication/components/SSOAuthenticationBox";
import useLocationQueryParams from "core/hooks/useLocationQueryParams";
import FullLoader from "core/components/Fullloader/FullLoader";

const LoginOidcCallback = () => {
  const query = useLocationQueryParams();
  const payload: OktaOidcCredentialsFormSchema = {
    single_use_token: query.get("single_use_token")!,
  };

  const { isError } = useOktaOidcLogin(payload);

  const { t } = useTranslation();

  if (isError) {
    return (
      <SSOAuthenticationBox>
        <Button variant="primary-solid" data-testid="okta-oidc-error" mt={3}>
          {t("okta.oidc.error")}
        </Button>
      </SSOAuthenticationBox>
    );
  }
  return (
    <SSOAuthenticationBox>
      <FullLoader />
    </SSOAuthenticationBox>
  );
};

export default LoginOidcCallback;
